const getUrl = (
  id: string | undefined,
  token: string,
  size?: number,
  timestamp?: string,
  isDownload?: number
) => {
  size = size || 0;
  timestamp = timestamp || "";
  isDownload = isDownload || 0;

  const baseUrl = window.location.origin;

  return `${baseUrl}/api/folder/get-file/${id}/${token}/${isDownload}/${size}`;
};

export default getUrl;
